import Gobalstore from "../index";
export const actions = {
  getFeeTypeLevel1: function (localStore) {
    this.axios({
      method: "GET",
      url: "/admin/guarded/main/feeTypeLevel1",
    }).then(function (response) {
      localStore.commit("setFeeTypeLevel1", response.data);
    });
  },
  getFeeTypeByParent: function (localStore, payload) {
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/feeTypeByParent/${payload.parent}`,
    }).then(function (response) {
      localStore.commit("setFeeTypeLevel"+payload.ATLevel, response.data);
    });
  },
  
  getFeeType: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: "/admin/guarded/management/feetype/",
    })
      .then(function (response) {
        localStore.commit("setFeeType", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  createFeeType: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/management/feetype/`,
      headers: payload.headers,
      data: payload.data,
    }).then(function (response) {
      Gobalstore.commit("LoadingOverlay", false);
      return response;
    }).catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error;
    });
  },

  updateFeeType: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "PUT",
      url: `/admin/guarded/management/feetype/`,
      headers: payload.headers,
      data: payload.data,
    }).then(function (response) {
      Gobalstore.commit("LoadingOverlay", false);
      return response;
    }).catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error;
    });
  },
};
